import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { useTranslation } from "react-i18next";
import Setting from "../Settings/Setting";

const Stack = createStackNavigator();

export interface BookingStackProps {}

const SettingStack: React.FC<BookingStackProps> = () => {
  const { t, i18n } = useTranslation();
  return (
    <Stack.Navigator>
       <Stack.Screen
        name="Setting"
        component={Setting}
        options={{
          title: t("HEADER_SETTING"),
          headerStyle: {
            backgroundColor: "#D71D9A",
          },
          headerTintColor: "#fff",
          headerTitleStyle: {
            fontWeight: "bold",
          },
        }}
      /> 
    </Stack.Navigator>
  );
};

export default SettingStack;
